// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rendered-content ol,.rendered-content ul{list-style:revert!important;padding-left:1.5rem!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
